import type { ChatItem } from '@/models/chat'
import { type InsuranceApplication, InsuranceApplicationSource } from '@/models/insuranceApplication'

export const MOCK_APPLICATION: InsuranceApplication = {
  id: 'demo-app',
  orgId: 'demo-org',
  dateCreated: '2026-06-01T12:00:00Z',
  dateUpdated: '2026-06-01T12:00:00Z',
  name: 'Demo Trucking Co',
  source: InsuranceApplicationSource.WEB,
  hasDispatchedIndications: false,
  awaitingCarrierCount: 0,
  progressiveNotRun: false,
  rocklakeManualLines: {},
  telematics: [],
  percentComplete: 12,
  progress: [
    { label: 'Business details', status: 'IN_PROGRESS' },
    { label: 'Drivers', status: 'LOCKED' },
    { label: 'Equipment', status: 'LOCKED' },
    { label: 'Review & submit', status: 'LOCKED' },
  ],
  chat: {
    id: 'demo-chat',
    dateCreated: '2026-06-01T12:00:00Z',
    dateUpdated: '2026-06-01T12:00:00Z',
    relatedModel: 'QUOTE',
    relatedModelId: 'demo-app',
    title: 'Demo chat',
    items: [],
  },
  action: { content: { component: 'LOADING' }, service: 'DEMO' },
  nextService: '',
  lastUsedService: '',
  indications: [],
  estimates: [],
  quotes: [],
  insurancePolicies: [],
  commodities: [],
  business: null,
  businessOwner: null,
  needsReviewAttestation: false,
  pendingChannelPick: null,
}

export const MOCK_MESSAGES: ChatItem[] = [
  {
    id: 'msg-1',
    dateCreated: '2026-06-01T12:00:00Z',
    dateUpdated: '2026-06-01T12:00:00Z',
    isFromUser: false,
    content: { component: 'P', content: 'Welcome to Cai, Carrie!' },
  },
  {
    id: 'msg-2',
    dateCreated: '2026-06-01T12:00:01Z',
    dateUpdated: '2026-06-01T12:00:01Z',
    isFromUser: false,
    content: {
      component: 'P',
      content:
        'We make it easy to get affordable, fair truck insurance in minutes. Once your coverage is active through Cai, we’ll proactively monitor your risk and keep you informed of any potential premium changes.',
    },
  },
  {
    id: 'msg-3',
    dateCreated: '2026-06-01T12:00:02Z',
    dateUpdated: '2026-06-01T12:00:02Z',
    isFromUser: false,
    content: { component: 'P', content: 'I’m Cai! I’ll guide you through your insurance application.' },
  },
  {
    id: 'msg-4',
    dateCreated: '2026-06-01T12:00:03Z',
    dateUpdated: '2026-06-01T12:00:03Z',
    isFromUser: false,
    content: {
      component: 'P',
      content:
        'Please share your mobile number to receive SMS updates about your insurance application — quote status, signature requests, and secure login links.',
    },
  },
  {
    id: 'msg-5',
    dateCreated: '2026-06-01T12:00:04Z',
    dateUpdated: '2026-06-01T12:00:04Z',
    isFromUser: true,
    content: { component: 'P', content: '+15133739707' },
  },
  {
    id: 'msg-7',
    dateCreated: '2026-06-01T12:00:06Z',
    dateUpdated: '2026-06-01T12:00:06Z',
    isFromUser: false,
    content: {
      component: 'P',
      content: 'We offer multiple providers with competitive coverage options. You’re in the right place.',
    },
  },
  {
    id: 'msg-8',
    dateCreated: '2026-06-01T12:00:07Z',
    dateUpdated: '2026-06-01T12:00:07Z',
    isFromUser: false,
    content: [
      { component: 'P', content: 'I’ll need to confirm a few details about:' },
      {
        component: 'UL',
        content: [
          { component: 'LI', content: 'Your business' },
          { component: 'LI', content: 'Your trucks' },
          { component: 'LI', content: 'Your drivers' },
        ],
      },
    ],
  },
]
